import { render, staticRenderFns } from "./ChooseEmissionButton.vue?vue&type=template&id=f5bd52b8&"
import script from "./ChooseEmissionButton.vue?vue&type=script&lang=js&"
export * from "./ChooseEmissionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports